import React from 'react';

import { StyledDesc, StyledDiv, StyledLang, StyledTable, StyledTbody, StyledTitle } from './GlobalError.style';

const GlobalError: React.FunctionComponent = () => {
  return <StyledDiv>
    <StyledTable>
      <StyledTbody>
        <tr>
          <td><img src="https://statics.luckycart.com/affiliations/images/error.svg" alt="Error"/></td>
          <td align="left">
            <StyledLang>
              <StyledTitle>(en) This page cannot be displayed</StyledTitle>
              <StyledDesc>Please send us an email providing the url of the page:&nbsp;
                <a href="mailto:customers@luckycart.com">customers@luckycart.com</a>.</StyledDesc>
            </StyledLang>
            <StyledLang>
              <StyledTitle>(fr) Impossible d&apos;afficher la page</StyledTitle>
              <StyledDesc>Merci d&apos;envoyer un email indiquant l&apos;url de cette page à&nbsp;
                <a href="mailto:customers@luckycart.com">customers@luckycart.com</a>.</StyledDesc>
            </StyledLang>
            <StyledLang>
              <StyledTitle>(de) Diese Seite kann nicht angezeigt werden</StyledTitle>
              <StyledDesc>
                Für weitere Informationen senden Sie bitte eine E-mail mit der URL dieser Seite an&nbsp;
                <a href="mailto:customers@luckycart.com">customers@luckycart.com</a>.
              </StyledDesc>
            </StyledLang>
            <StyledLang>
              <StyledTitle>(nl) De pagina kan niet weergegeven worden</StyledTitle>
              <StyledDesc>Voor meer informatie, gelieve een e-mail met vermelding van de URL van deze pagina naar&nbsp;
                <a href="mailto:customers@luckycart.com">customers@luckycart.com</a> te sturen.
              </StyledDesc>
            </StyledLang>
          </td>
        </tr>
      </StyledTbody>
    </StyledTable>
  </StyledDiv>;
};

export default GlobalError;
